// values from _variables.scss
export enum BreakPoints {
  xs = 0,
  sm = 576,
  md = 768,
  lg = 992,
  xl = 1200,
  xxl = 1420,
  xxxl = 1640
}
